import Vue from 'vue'
import axios from 'axios'
import { mapState } from 'vuex'

import Confirm from '@/components/confirmation-modal/confirm.vue'
import Loading from '@/components/loading/loading.vue'

export default Vue.extend({
  name: 'Check',
  components: {
    Confirm,
    Loading
  },
  data () {
    return {
      userToken: localStorage.getItem('token'),
    }
  },
  computed: {
    ...mapState(['loading'])
  },
  created() {
    this.$store.dispatch('loading')

    const axiosConfig = {
      headers: {
        'Authorization': `Bearer ${this.userToken}`
      }
    }
    const data = {
      order_id: this.$route.query.order_id,
    }

    const url = `${process.env.VUE_APP_API_BASE_URL}/paypay_042ce1d98e7099d76917/check_payment`

    return axios.post(url, data, axiosConfig)
      .then((res) => {
        this.$router.push({ path: `/payment/${this.$route.params.id}/complete` })
      })
      .catch((e) => {
        console.log(e.response.data.message)

        this.$notify({
          title: 'エラー',
          text: '決済の確認に失敗しました。',
          type: 'error'
        })

        this.$router.push({ path: '/dashboard' })
      })
  }
})
